import React from 'react';
import {
  Box,
  Paper,
  Typography,
  LinearProgress,
  Alert,
  CircularProgress,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const GenerationStatusCard = ({ status, type = 'look', currentMessage }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'queued':
        return {
          icon: <HourglassEmptyIcon sx={{ fontSize: 40 }} color="info" />,
          title: `${type === 'look' ? 'Look' : 'Video'} Generation Queued`,
          subtitle: 'Your request is in the queue. Processing will begin shortly...',
          color: 'info',
          showProgress: true,
        };
      case 'processing':
        return {
          icon: <CircularProgress size={40} />,
          title: `Generating ${type === 'look' ? 'Look' : 'Video'}...`,
          subtitle: currentMessage || 'This may take a few moments. Please wait...',
          color: 'primary',
          showProgress: true,
        };
      case 'completed':
        return {
          icon: <CheckCircleIcon sx={{ fontSize: 40 }} color="success" />,
          title: 'Generation Complete!',
          subtitle: `Your ${type} has been generated successfully.`,
          color: 'success',
          showProgress: false,
        };
      case 'failed':
        return {
          icon: <ErrorIcon sx={{ fontSize: 40 }} color="error" />,
          title: 'Generation Failed',
          subtitle: 'Something went wrong. Please try again.',
          color: 'error',
          showProgress: false,
        };
      case 'pending_consent':
        return {
          icon: <HourglassEmptyIcon sx={{ fontSize: 40 }} color="warning" />,
          title: 'Consent Required',
          subtitle: 'Your look is awaiting consent and will be ready once approved.',
          color: 'warning',
          showProgress: false,
        };
      default:
        return {
          icon: <CircularProgress size={40} />,
          title: 'Processing...',
          subtitle: 'Please wait...',
          color: 'primary',
          showProgress: true,
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        textAlign: 'center',
        border: '2px solid',
        borderColor: `${config.color}.main`,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        {config.icon}
      </Box>

      <Typography variant="h6" fontWeight={600} gutterBottom>
        {config.title}
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {config.subtitle}
      </Typography>

      {config.showProgress && (
        <LinearProgress
          color={config.color}
          sx={{
            height: 6,
            borderRadius: 3,
          }}
        />
      )}

      {status === 'failed' && (
        <Alert severity="error" sx={{ mt: 2 }}>
          If the problem persists, please contact support.
        </Alert>
      )}
    </Paper>
  );
};

export default GenerationStatusCard;
